<ng-template #modalLG let-modal style="border-radius: 8px">

    <div class="modal-header p-0" style="background-color: transparent;">
        <button type="button" class=" close" style="margin-right: 5px" (click)="modal.dismiss('Cross click')"
                aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div style="margin: 64px">
        <div class="text-center mb-4">

            <h4 class="siz e24">Réinitialiser le stock</h4>
            <p style="color: #2F2B3DE5" class="size18">L'opération de remise à zéro permet de remettre
                à l'état initial votre stock tels que la quantité,
                les derniers prix d'achat et l'état des produits.
            </p>
        </div>
        <div style="padding-left: 300px; margin-bottom: 24px" >
            <img [src]="file" class="logo-img">
        </div>



        <div class=" modal-body p-0" tabindex="0" ngbAutofocus>

            <ngb-alert [type]="'danger'" [dismissible]="false">
                <div class="pt-1 alert-body" style="background-color: #CB3A3A29">
                    <div class="items">
                        <div class=" alert-icon">
                            <i data-feather="alert-circle"   [size]="18"></i>
                        </div>
                        <div>
                            <p class="size18">Attention </p>
                            <p>  Une fois validée, cette opération ne peut plus être annulée. (cette action est irréversible) .</p>
                        </div>

                    </div>

                </div>
            </ngb-alert>
            <div class="form-group">
                <label for="account-new-password">Mot de passe</label>
                <div class="input-group form-password-toggle input-group-merge"
                     [class.password-invalid]="passwordError">
                    <input
                            [type]="passwordTextTypeNew ? 'text' : 'password'"
                            id="account-new-password"
                            name="reset-stock-confirm"
                            class="form-control"
                            [class.is-invalid]="passwordError"
                            placeholder="Entrez votre mot de passe"
                            autocomplete="new-password"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                            data-form-type="other"
                            data-lpignore="true"
                            data-1p-ignore="true"
                            [(ngModel)]="password"
                            (ngModelChange)="onPasswordChange()"
                    />
                    <div class="input-group-append">
                                <span class="input-group-text cursor-pointer"
                                ><i
                                        class="feather font-small-4"
                                        [ngClass]="{
                                      'icon-eye-off': passwordTextTypeNew,
                                      'icon-eye': !passwordTextTypeNew
                                    }"
                                        (click)="togglePasswordTextTypeNew()"
                                ></i
                                ></span>
                    </div>
                </div>
                <small class="text-danger d-block mt-1" *ngIf="passwordError">{{ passwordError }}</small>
            </div>

        </div>
        <div class="centerButtons">
            <button type="button" class="btn btn-primary" (click)="confirmReset()"  [disabled]="loading || !password?.trim()" rippleEffect>
                <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                {{ loading ? 'Traitement...' : 'Confirmer' }}
            </button>
            <button type="button" class="btn " style="color: #808390; background-color: #80839029" (click)="modal.dismiss('Cancel click')" [disabled]="loading" rippleEffect>Annuler</button>
        </div>

    </div>
</ng-template>
